import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SchoolEventForm } from '../Forms/SchoolEventForm';

type SchoolEventModalProps = {
  selectedEventUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const SchoolEventModal = ({ selectedEventUuid, isOpen, onClose }: SchoolEventModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      title={selectedEventUuid ? t('schoolEvents.edit') : t('schoolEvents.add')}
      isOpen={isOpen}
      onRequestClose={onClose}
      loading={loading}
    >
      <SchoolEventForm onLoading={setLoading} onClose={onClose} eventUuid={selectedEventUuid} />
    </Modal>
  );
};
